<template>
    <div class="pet-quote-step select-coverage">
        <quote-step-header
            :title="subStepFields.title"
            :key="subStepFields.title"
            :subtitle="subStepFields.subtitle"
        ></quote-step-header>

        <form class="quote-form" @submit.prevent="next">
            <div class="form-row center mt-8 mb-16">
                <app-text-radio-buttons
                    v-model="form[stepName].coverage"
                    :items="petType"
                    :break-mobile="true"
                >
                </app-text-radio-buttons>
            </div>
            <div>
                <transition name="slide-fade">
                    <div v-if="!!filledCoverage">
                        <app-label>{{ trans("labels.pet_sex") }}</app-label>
                        <app-text-radio-buttons
                            class="mb-16"
                            v-model="form[stepName].sex"
                            :items="petSex"
                            :break-mobile="true"
                        ></app-text-radio-buttons>

                        <app-label>
                            {{ trans("labels.pet_breed") }}
                        </app-label>

                        <app-text-radio-buttons
                            class="mb-16"
                            v-model="form[stepName].breed"
                            :items="petBreed"
                            :break-mobile="true"
                        ></app-text-radio-buttons>

                        <app-label v-if="isShowBreedOptions">
                            {{ trans("labels.dog_breed") }}
                        </app-label>

                        <select
                            v-if="isShowBreedOptions"
                            id="breeds"
                            name="sugGeza"
                            class="app-quote-dropdown"
                            v-model="form[stepName].sugGeza"
                        >
                            <option
                                v-for="option in petOptions"
                                :value="option.fnx_id"
                                :key="option.fnx_id"
                            >
                                {{ option.name }}
                            </option>
                        </select>
                    </div>
                </transition>
            </div>
            <div class="submit-row">
                <app-button :disabled="disabledConditions" :loading="loading">
                    {{ "quote.welcome.next" | __ }}
                </app-button>
            </div>
        </form>
    </div>
</template>

<script>
import QuoteStep from "../../../mixins/QuoteStep";
import AppInput from "../../Forms/Input.vue";
import AppLabel from "../../Forms/Label.vue";

export default {
    name: "PetQuoteSelectCoverage",
    components: {AppInput, AppLabel},
    mixins: [QuoteStep],

    props: {},

    data() {
        return {
            subSteps: ["default"]
        };
    },

    computed: {
        isShowBreedOptions() {
          return this.form[this.stepName].coverage === this.constants.DOG &&
              this.form[this.stepName].breed === this.constants.BREED
        },
        petType() {
            return [
                {
                    label: this.trans("types.dog"),
                    value: this.constants.DOG,
                    icon: "dog",
                    icon_checked: "dog-checked"
                },
                {
                    label: this.trans("types.cat"),
                    value: this.constants.CAT,
                    icon: "cat",
                    icon_checked: "cat-checked"
                }
            ];
        },
        petOptions() {
            return this.constants.breeds
        },
        petSex() {
            return [
                {
                    label: this.trans("types.male"),
                    value: this.constants.MALE
                },
                {
                    label: this.trans("types.female"),
                    value: this.constants.FEMALE
                }
            ];
        },
        petBreed() {
            return [
                {
                    label: this.trans("types.breed"),
                    value: this.constants.BREED
                },
                {
                    label: this.trans("types.mixed"),
                    value: this.constants.MIXED
                }
            ];
        },
        filledCoverage() {
            return [this.constants.DOG, this.constants.CAT].includes(
                this.coverage
            );
        },
        coverage() {
            return this.form[this.stepName].coverage;
        },

        canMoveNext() {
            return (
                this.filledCoverage &&
                this.form[this.stepName].sex &&
                this.form[this.stepName].breed &&
                (
                    (this.form[this.stepName].coverage === this.constants.DOG &&
                        this.form[this.stepName].breed === this.constants.BREED) ?
                        this.form[this.stepName].sugGeza :
                        true
                )
            );
        }

    }
};
</script>

<style lang="scss" scoped>
.quote-form {
    max-width: $tablet;
    height: auto;
}

.floors {
    display: flex;
    gap: 40px;

    @media (max-width: $tablet) {
        flex-direction: column;
    }

    > div {
        flex: 1;
    }
}

.app-quote-dropdown {
    font-size: 20px;
    font-weight: 600;
    color: $dark-gray;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    border: solid 1px rgba(33, 67, 146, 0.2);
    background-color: $lightest-gray;
    transition: border 0.2s ease-in-out;
    cursor: pointer;
    border-radius: 100px;
    width: 100%;
}

ul {
    list-style: disc;
}
</style>
